// SPDX-License-Identifier: AGPL-3.0-or-later

import type {RoomLayout, Vec3} from '@app/features/voice_scene/scene/VoiceSceneTypes';

// Beside the stand point rather than on it, where a third turn of standers would go (useRoomAvatars).
const HOST_SHIFT_M = -0.75;

const distance2 = (a: Vec3, b: Vec3): number => (a.x - b.x) ** 2 + (a.y - b.y) ** 2 + (a.z - b.z) ** 2;

// Where a bot's host character stands: by the TV (the stand point nearest its centre), in a room without one at the
// first stand point, in a room without stand points at the room target.
export function stageHostSpot({screen, stands, camTarget}: Pick<RoomLayout, 'screen' | 'stands' | 'camTarget'>): Vec3 {
	let point = stands[0] ?? camTarget;
	if (screen)
		for (const stand of stands) if (distance2(stand, screen.center) < distance2(point, screen.center)) point = stand;
	return {...point, x: point.x + HOST_SHIFT_M};
}
